module.exports = __webpack_public_path__ + "img/Calendar.686924ef.png";